/* eslint-disable no-unreachable */
import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { ThemeAnimationType, useModeAnimation } from 'react-theme-switch-animation'
import { setAppTheme } from '@/store/app'
import mixpanelService from '@/services/analytics/Mixpanel'

function getPreferredTheme() {
  if (typeof window === 'undefined') return 'light'
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function getIsDarkFromDom() {
  if (typeof document === 'undefined') return false
  const attr = document.documentElement.getAttribute('data-theme')
  if (attr === 'dark' || attr === 'light') return attr === 'dark'
  if (typeof localStorage === 'undefined') return false
  return localStorage.getItem('theme') === 'dark'
}

function useTheme() {
  // /**
  //  * ? ------------------------
  //  * ! ----Remove dark mode----
  //  * * ------------------------
  //  */
  // localStorage.removeItem('theme')
  // return { theme: '', toggleTheme: () => {} }
  // /**
  //  * * ------------------------
  //  * ! ----Remove dark mode----
  //  * ? ------------------------
  //  */

  const [theme, setTheme] = useState(getPreferredTheme)
  const dispatch = useDispatch()

  const getTheme = () => {
    if (typeof localStorage === 'undefined') return 'light'
    return localStorage.getItem('theme') || 'light'
  }

  const applyTheme = useCallback(
    (newTheme, { track = true } = {}) => {
      if (typeof document !== 'undefined') document.documentElement.setAttribute('data-theme', newTheme)
      localStorage.setItem('theme', newTheme)
      dispatch(setAppTheme(newTheme))
      if (track) mixpanelService.addProperty('theme', newTheme)
      setTheme(newTheme)
    },
    [dispatch],
  )

  const toggleTheme = () => {
    applyTheme(getTheme() === 'light' ? 'dark' : 'light')
  }

  const initTheme = () => {
    if (typeof window === 'undefined') return
    const storedTheme = localStorage.getItem('theme') || getPreferredTheme()
    applyTheme(storedTheme, { track: false })
  }

  return { initTheme, theme, toggleTheme, getTheme, applyTheme }
}

export function useThemeSwitchAnimation() {
  const themeApi = useTheme()
  const { applyTheme } = themeApi

  const handleDarkModeChange = useCallback(
    isDark => {
      applyTheme(isDark ? 'dark' : 'light')
    },
    [applyTheme],
  )

  const { ref: themeSwitchRef, toggleSwitchTheme, isDarkMode } = useModeAnimation({
    isDarkMode: getIsDarkFromDom(),
    onDarkModeChange: handleDarkModeChange,
    animationType: ThemeAnimationType.POLYGON_GRADIENT,
    duration: 600,
  })

  return {
    ...themeApi,
    themeSwitchRef,
    toggleSwitchTheme,
    isDarkMode,
  }
}

export default useTheme
